import React, { useCallback, useEffect, useState } from "react";
import styled from 'styled-components';
import theme from "../../styles/theme";
import { ExpandLess } from "@mui/icons-material";
import { Button, Collapse } from "@mui/material";
import TimeTable from "./TimeTable";
import { useGetProjectSurveyTimesetList, useSetProjectSurveyTimeTable } from "../../interfaces/survey";
import { useQueryClient } from "react-query";
import { MODAL_QUERY_NM } from "../../interfaces/modal";
import CommonTab from "../common/CommonTab";
import { DesktopDatePicker, DesktopTimePicker } from "@mui/x-date-pickers";
import moment from "moment";

const MainWrap = styled.div`
    // width: 22rem;
    // min-width: 22rem;
    height: 100%;
    overflow: hidden;
    padding: 0.5rem;
    // display: flex;
    // flex-direction: column;
    
`;
const TitleArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
`;

const SurveyTimeSetList = ({survey}) => {

    const {sid, time_unit} = survey
    
    const [dayList, setDayList] = useState([]);
    const [list, setList] = useState();

    const [addDate, setAddDate] = useState();

    const [tabIndex, setTabIndex] = useState(0);

    const {data, refetch} = useGetProjectSurveyTimesetList(sid);

    useEffect(()=>{
        refetch();
    },[sid])

    useEffect(()=>{
        refetch();
    },[time_unit])

    useEffect(()=>{
        if(data){
            setList(data);
            const temp = data.map((item)=>moment(item.sdate).format('YYYY-MM-DD(dd)'));
            const set = new Set(temp);
            setDayList([...set]);
        }else{
            setList();
            setDayList([]);
        }
    },[data])

    const handleAddDay = () => {
        if(addDate){
            const search = dayList.indexOf(addDate);
            (search < 0) && setDayList([...dayList,addDate])
        }
    }

    return (
        <MainWrap>
            <div style={{display:'flex', justifyContent:'flex-end',gap:'0.5rem'}}>
                <DesktopDatePicker
                    id='addDate'
                    format='YYYY-MM-DD(dd)'
                    // size='small'
                    slotProps={{ textField: { size: 'small'} }}
                    value={addDate && moment(addDate)}
                    onChange={(value)=>setAddDate(value.format('YYYY-MM-DD(dd)'))}
                />
                <Button variant='contained' onClick={handleAddDay}>조사일 추가</Button>
            </div>
            <CommonTab tabList={dayList} onClick={setTabIndex}/>
            <div style={{height:'0.5rem'}}/>
            <div style={{height:'calc(100% - 6rem)',overflow: 'auto'}}>
                {(list && list.length > 0) && 
                    list.filter((fItem)=>fItem.sdate===moment(dayList[tabIndex]).format('YYYY-MM-DD')).map((item)=>(
                        <ListItem sid={sid} sdate={item.sdate} item={item} time_unit={time_unit}/>
                        )
                )}
                {dayList.length > 0 && <ListItem sid={sid} sdate={moment(dayList[tabIndex]).format('YYYY-MM-DD')} item={null} time_unit={time_unit}/>}
            </div>
            {/* <TimeTable name={'조사일'} list={list} titleFlag={true} time_unit={time_unit} handleAddClick={(target)=>handleAddClick(target)} handleModClick={(target)=>handleUpdateClick(target)}/> */}
        </MainWrap>
    )
}

const ListItemWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0.5rem;
    gap: 0.5rem;
`;

const ListItem = ({sid, sdate, item, time_unit}) => {

    const queryClient = useQueryClient();

    const [target, setTarget] = useState();

    const {mutate} = useSetProjectSurveyTimeTable();

    useEffect(()=>{
        setTarget(item);
    },[item])

    const handleValueChange = (id,val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }


    const handleAddClick = useCallback((updateItem) => {
        const temp = {
            mode: 'POST',
            ...updateItem,
            sdate: sdate,
            sid: sid
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'추가하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleUpdateClick = useCallback((updateItem,sid) => {
        const temp = {
            mode: 'PUT',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'수정하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDeleteClick = useCallback((updateItem,sid) => {
        const temp = {
            mode: 'DELETE',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    return (
        <ListItemWrap>
            <DesktopTimePicker
                id='stime'
                format='HH:mm'
                timeSteps={{minutes:time_unit/60}}
                slotProps={{ textField: { size: 'small'} }}
                value={(target && target.seq) ? moment(sdate +' '+target.stime):undefined}
                onChange={(value)=>handleValueChange('stime', value.format('HH:mm'))}
            />
            <span>~</span>
            <DesktopTimePicker
                id='etime'
                format='HH:mm'
                timeSteps={{minutes:time_unit/60}}
                slotProps={{ textField: { size: 'small'} }}
                value={(target && target.seq) ? moment(sdate +' '+target.etime):undefined}
                onChange={(value)=>handleValueChange('etime', value.format('HH:mm'))}
            />
            {(target && target.seq) ? 
                <React.Fragment>
                    <Button variant='contained' onClick={()=>handleUpdateClick(target)}>수정</Button>
                    <Button variant='contained' onClick={()=>handleDeleteClick(target)}>삭제</Button>
                </React.Fragment>
                :
                <Button variant='contained' onClick={()=>handleAddClick(target)}>추가</Button>
            }
        </ListItemWrap>
    )
}

export default SurveyTimeSetList;